import { render, staticRenderFns } from "./ContactEditDialog.vue?vue&type=template&id=2d5081c4&scoped=true"
import script from "./ContactEditDialog.vue?vue&type=script&lang=js"
export * from "./ContactEditDialog.vue?vue&type=script&lang=js"
import style0 from "./ContactEditDialog.vue?vue&type=style&index=0&id=2d5081c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5081c4",
  null
  
)

export default component.exports